exports.ACTIONS = {
  initLegacy: 'init',
  handshake: 'hs',
  queryFetch: 'qf',
  querySubscribe: 'qs',
  queryUnsubscribe: 'qu',
  queryUpdate: 'q',
  bulkFetch: 'bf',
  bulkSubscribe: 'bs',
  bulkUnsubscribe: 'bu',
  fetch: 'f',
  subscribe: 's',
  unsubscribe: 'u',
  op: 'op',
  snapshotFetch: 'nf',
  snapshotFetchByTimestamp: 'nt',
  presence: 'p',
  presenceSubscribe: 'ps',
  presenceUnsubscribe: 'pu',
  presenceRequest: 'pr'
};
